<template>
  <v-container fluid class="px-0">
    <v-row class="asc-custom-alerts--header" no-gutters>
      <v-col>
        <asc-notification
          v-if="isAnyNotificationActive"
          :definition="getActiveNotifications"
          :on-close="handleActivationNotificationClose"
        ></asc-notification>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AscNotification from '@/components/molecules/AscNotification'
import { CUSTOM_ALERT_CONSTS as CAC } from '@/stores/consts'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AscCustomAlertsNotificationsWrapper',

  components: {
    AscNotification,
  },

  props: {
    isTailNotificationActive: Boolean,
    isFlightPhaseNotificationActive: Boolean,
    isThresholdNotificationActive: Boolean,
    isAtaChapterNotificationActive: Boolean,
    isReportPersistenceNotificationActive: Boolean,
    isDaysPersistenceNotificationActive: Boolean,
    isFlightsPersistenceNotificationActive: Boolean,
    isRecommendedActionNotificationActive: Boolean,
    isLogicBuilderNotificationActive: Boolean,
    isSticky: Boolean,
    logicStringErrorMessage: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      notifications: [
        {
          prop: 'isTailNotificationActive',
          message: 'Please select an aircraft.',
        },
        {
          prop: 'isThresholdNotificationActive',
          message: 'Please select a valid threshold.',
        },
        {
          prop: 'isFlightPhaseNotificationActive',
          message: 'Please select a flight phase.',
        },
        {
          prop: 'isAtaChapterNotificationActive',
          message: 'Please select an ATA Chapter.',
        },
        {
          prop: 'isReportPersistenceNotificationActive',
          message: 'Please enter a valid unit value 1-60.',
        },
        {
          prop: 'isDaysPersistenceNotificationActive',
          message: 'Please enter a valid unit value 1-30.',
        },
        {
          prop: 'isFlightsPersistenceNotificationActive',
          message: 'Please enter a valid frequency logic.',
        },
        {
          prop: 'isRecommendedActionNotificationActive',
          message: 'Please enter a recommended action.',
        },
        {
          prop: 'isLogicBuilderNotificationActive',
          message: '',
        },
      ],
      activeNotifications: [],
    }
  },

  computed: {
    ...mapState(CAC.NAMESPACE, ['activeNotificationsState']),
    isAnyNotificationActive() {
      return (
        this.activeNotifications.length > 0 ||
        this.activeNotificationsState.length > 0
      )
    },
    getActiveNotifications() {
      return this.activeNotifications.length > 0
        ? this.activeNotifications
        : this.activeNotificationsState
    },
  },

  watch: {
    isTailNotificationActive: 'updateNotifications',
    isFlightPhaseNotificationActive: 'updateNotifications',
    isThresholdNotificationActive: 'updateNotifications',
    isAtaChapterNotificationActive: 'updateNotifications',
    isReportPersistenceNotificationActive: 'updateNotifications',
    isDaysPersistenceNotificationActive: 'updateNotifications',
    isFlightsPersistenceNotificationActive: 'updateNotifications',
    isRecommendedActionNotificationActive: 'updateNotifications',
    isLogicBuilderNotificationActive: 'updateNotifications',
  },

  methods: {
    ...mapActions(CAC.NAMESPACE, [CAC.UPDATE_ACTIVATION_NOTIFICATIONS]),
    updateNotifications() {
      this.activeNotifications = this.notifications
        .filter(notification => this[notification.prop])
        .map(notification => ({
          text:
            notification.prop === 'isLogicBuilderNotificationActive'
              ? this.logicStringErrorMessage
              : notification.message,
          mode: 'alert',
          color: 'error',
          isActive: true,
          type: 'error',
          dismissible: true,
        }))

      if (this.activeNotifications.length > 0) {
        this.activeNotifications.push({
          text: 'Activation Error: Please correct all field errors to activate your alert',
          mode: 'alert',
          color: 'error',
          isActive: true,
          type: 'error',
          dismissible: true,
        })
      }

      this[CAC.UPDATE_ACTIVATION_NOTIFICATIONS](this.activeNotifications)
    },

    handleActivationNotificationClose(event) {
      let activeNotificationsStateNew = []
      this.activeNotifications.length > 0
        ? (this.activeNotifications = this.activeNotifications.map(
            notification =>
              notification.text === event.text
                ? { ...notification, isActive: false }
                : notification,
          ))
        : (activeNotificationsStateNew = this.activeNotificationsState.map(
            notification =>
              notification.text === event.text
                ? { ...notification, isActive: false }
                : notification,
          ))
      this[CAC.UPDATE_ACTIVATION_NOTIFICATIONS](activeNotificationsStateNew)
    },
  },
}
</script>
